<template>
    <div>
        <section class="w-full bg-blue-100">
            <div class="bg-white rounded-b-2xl">
                <div class="self-gutter">
                    <div class="self-gutter-y self-content-sm">
                        <ReportNavigation v-if="this.$route.path.startsWith(`/${$i18n.locale}/reports`)"/>
                        <h1 class="title-2xl">{{ $t('service_report.title') }}</h1>
                        <AlertSummary v-if="!generateReportOk" :main-text="$t('error.main_text')" :secondary-text="$t('error.secondary_text')" alert-classes="mt-24 e5-form-error-summary--error"/>

                        <div class="pt-24 self-hero-intro" :class="{ 'show-full-desc': showFullDesc }">
                            <p v-html="$t('service_report.desc')" ref="descContainer"></p>
                        </div>
                        <!-- REPORT FROM -->
                        <!-- Service report form -->
                        <div class="pt-24 self-form-wrap">

                            <div class="w-full sm:w-5/12 self-form-wrap-item" :class="{'e5-error': !generateReportOk}">
                                <label class="self-form-item-label"
                                       for="title">{{ $t('reports.form.period') }}:</label>
                                <div class="relative">
                                    <button ref="calendarButton" id="calendar" class="e5-input-calendar"
                                            :class="{'e5-error': !generateReportOk}"
                                            aria-haspopup="true" aria-expanded="false"
                                            @click="dropdown('calendarButton')">
                                        <span :class="{'text-alert': !generateReportOk}">
                                    {{
                                                ServiceByDateRequest.service.servicestartdate || ServiceByDateRequest.service.serviceenddate ? selectedDateRange : $t('reports.form.period_placeholder')
                                            }}</span>
                                    </button>

                                    <div class="e5-input-icon">
                                        <CalendarSVG/>
                                    </div>
                                    <DropDownCalendar v-model="selectedDateRange" @input="handleDateChange"/>
                                </div>
                                <a class="hover:text-blue-400 cursor-pointer"
                                   @click="quickSelectDates('currentMonth')">{{ $t('reports.form.current_month') }}</a>
                                |
                                <a class="hover:text-blue-400 cursor-pointer"
                                   @click="quickSelectDates('lastMonth')">{{ $t('reports.form.last_month') }}</a> |
                                <a class="hover:text-blue-400 cursor-pointer"
                                   @click="quickSelectDates('currentYear')">{{ $t('reports.form.current_year') }}</a> |
                                <a class="hover:text-blue-400 cursor-pointer"
                                   @click="quickSelectDates('lastYear')">{{ $t('reports.form.last_year') }}</a>
                            </div>

                            <div class="w-full xs:w-1/2 sm:w-3/12 self-form-wrap-item">
                                <label class="self-form-item-label"
                                       for="search-by">{{ $t('reports.form.search_by') }}:</label>
                                <div class="relative">
                                    <div class="self-form-select-wrap">
                                        <select class="e5-select" name="search-by" id="search-by"
                                                v-model="ServiceByDateRequest.datetype">
                                            <option value="SERVICE_DATE">{{
                                                    $t('reports.form.search_by_option1')
                                                }}
                                            </option>
                                            <option value="INVOICE_DATE">{{
                                                    $t('reports.form.search_by_option2')
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="w-full xs:w-1/2 sm:w-4/12 self-form-wrap-item">
                                <label class="self-form-item-label"
                                       for="title">{{ $t('reports.form.sales_channels') }}:</label>

                                <div class="flex">
                                    <div class="block mr-24">
                                        <input class="e5-checkbox" checked type="checkbox" id="online" name="online"
                                               value="ONLINE" v-model="selectedSalesChannels">
                                        <label class="" for="online">
                                            {{ $t('reports.form.online') }}
                                        </label>
                                    </div>

                                    <div class="block">
                                        <input class="e5-checkbox" checked type="checkbox" id="offline" name="offline"
                                               value="OFFLINE" v-model="selectedSalesChannels">
                                        <label class="" for="offline">
                                            {{ $t('reports.form.offline') }}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="w-1/2 sm:w-5/12 self-form-wrap-item">
                                <label class="self-form-item-label"
                                       for="destination">{{ $t('reports.form.destination') }}:</label>
                                <div class="relative">
                                    <div class="self-form-select-wrap">
                                        <select multiple name="destination" id="destination"
                                                class="self-multiselect">
                                            <option v-bind:value="''"></option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <!--                            TODO: Kas seda on üldse vaja või võib ära jätta -->
                            <!--                            <div class="w-1/2 sm:w-3/12 self-form-wrap-item">-->
                            <!--                                <label class="self-form-item-label" for="service-provider">Service provider:</label>-->
                            <!--                                <div class="relative">-->
                            <!--                                    <div class="self-form-select-wrap">-->
                            <!--                                        <select name="service-provider" id="service-provider" multiple="multiple" class="self-multiselect">-->
                            <!--                                            <option value="one">Service provider</option>-->
                            <!--                                            <option value="two">Service provider 2</option>-->
                            <!--                                            <option value="three">Service provider 3</option>-->
                            <!--                                            <option value="four">Service provider 4</option>-->
                            <!--                                        </select>-->
                            <!--                                    </div>-->
                            <!--                                </div>-->
                            <!--                            </div>-->
                            <div class="w-full sm:w-4/12 self-form-wrap-item">
                                <label class="self-form-item-label"
                                       for="reference">{{ $t('reports.form.customer_reference') }}:</label>
                                <div class="relative">
                                    <input type="text" id="reference" checked placeholder="" name="reference"
                                           class="self-form-input"
                                           v-model="ServiceByDateRequest.booking.customerreference">
                                </div>
                            </div>

                            <div class="w-full self-form-wrap-item">
                                <div class="flex justify-between">
                                    <label class="self-form-item-label"
                                           for="groups">{{ $t('reports.form.service_groups') }}:</label>
                                    <button v-if="this.SelectedToplevels.length === 0" class="self-btn-plain"
                                            @click="selectAllTopleveles"><span
                                        class="self-btn-plain__text">{{ $t('reports.form.select_all') }}</span>
                                    </button>
                                    <button v-else class="self-btn-plain" @click="clearServiceGroups">
                                        <span class="self-btn-plain__text">{{ $t('reports.form.clear_all') }}</span>
                                    </button>
                                </div>

                                <ul class="self-checkboxes-list">
                                    <!--eslint-disable-next-line-->
                                    <li v-for="(item, index) in toplevel" v-bind:key="index" v-if="index % 2 === 0">
                                        <div class="block">
                                            <input type="checkbox" :id="item.toplevel_id"
                                                   :value="{ toplevel_id: item.toplevel_id, toplevel_name: item.toplevel_name }"
                                                   class="e5-checkbox" checked v-model="SelectedToplevels">
                                            <label :for="item.toplevel_id">{{ item.toplevel_name }}</label>
                                        </div>
                                        <!-- Check if there's a next item and display it -->
                                        <div class="block" v-if="toplevel[index + 1]">
                                            <input type="checkbox" :id="toplevel[index + 1].toplevel_id"
                                                   :value="{ toplevel_id: toplevel[index + 1].toplevel_id, toplevel_name: toplevel[index + 1].toplevel_name }"
                                                   class="e5-checkbox" checked v-model="SelectedToplevels">
                                            <label :for="toplevel[index + 1].toplevel_id">{{
                                                    toplevel[index + 1].toplevel_name
                                                }}</label>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <div aria-labelledby="hiddenrow" class="flex flex-wrap w-full max-h-0 overflow-hidden">
                                <div class="w-1/2 sm:w-1/4 self-form-wrap-item">
                                    <label class="self-form-item-label"
                                           for="code">{{ $t('reports.form.project_code') }}:</label>
                                    <div class="relative">
                                        <input type="text" id="code" placeholder="" name="code"
                                               class="self-form-input"
                                               v-model="ServiceByDateRequest.booking.projectcode">
                                    </div>
                                </div>
                                <div class="w-1/2 sm:w-1/4 self-form-wrap-item">
                                    <label class="self-form-item-label"
                                           for="budget">{{ $t('reports.form.budget_code') }}:</label>
                                    <div class="relative">
                                        <input type="text" id="budget" placeholder="" name="budget"
                                               class="self-form-input"
                                               v-model="ServiceByDateRequest.booking.budgetcode">
                                    </div>
                                </div>

                                <div class="w-1/2 sm:w-1/4 self-form-wrap-item">
                                    <label class="self-form-item-label"
                                           for="account">{{ $t('reports.form.fin_account') }}:</label>
                                    <div class="relative">
                                        <input type="text" id="account" placeholder="" name="account"
                                               class="self-form-input"
                                               v-model="ServiceByDateRequest.booking.finaccount">
                                    </div>
                                </div>
                                <div class="w-1/2 sm:w-1/4 self-form-wrap-item">
                                    <label class="self-form-item-label"
                                           for="me">{{ $t('reports.form.me_number') }}:</label>
                                    <div class="relative">
                                        <input type="text" id="me" placeholder="" name="me"
                                               class="self-form-input"
                                               v-model="ServiceByDateRequest.booking.menumber">
                                    </div>
                                </div>
                            </div>

                            <div class="self-form-wrap-actions">
                                <div>
                                    <button v-if="$store.state.invoiceExtraFields" ref="animateToggleButton"
                                            aria-expanded="false"
                                            id="hiddenrow" class="self-btn-plain"
                                            @click="animatetoggle('animateToggleButton')" data-toggle="animatetoggle">

                                        <span class="self-btn-plain__text">{{ $t('reports.form.more_options') }}</span>
                                        <span class="self-btn-plain__icon self-moreinfo-icon"><IconArrowForwardSVG/></span>
                                    </button>
                                </div>

                                <div class="flex xs-down:justify-end xs-down:pt-24">
                                    <a class="mr-24 self-btn-secondary hover:cursor-pointer"
                                       @click="clearAll">{{ $t('reports.form.clear_all') }}</a>

                                    <button class="self-btn-primary" @click="generateOnClick(ServiceByDateRequest)">
                                        {{ $t('reports.form.generate_report') }}
                                    </button>
                                </div>
                            </div>

                        </div>
                        <!-- TABLIST FOR REPORT TABLE -->
                        <div v-if="ServiceByDateResponce && requestSent" class="pt-24 -mb-24 md:-mb-48">
                            <ul class="self-table-tab-controls" role="tablist">
                                <li role="presentation">
                                    <a class="self-table-tab-control-item" href="#summary" role="tab" id="summary"
                                       aria-selected="true">{{ $t('reports.table.summary') }}</a>
                                </li>
                                <li role="presentation">
                                    <a class="self-table-tab-control-item" href="#detailed" role="tab" id="detailed"
                                       tabindex="-1">{{ $t('reports.table.detailed') }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Service report table -->
        <article v-if="ServiceByDateResponce && requestSent">
            <div id="resultsTable" class="relative bg-blue-100 rounded-b-2xl self-gutter-y">
                <div class="self-gutter">
                    <div class="self-content">

                        <!-- Summary view -->
                        <div class="w-full" id="summary" role="tabpanel" aria-labelledby="summary"
                             aria-hidden="false" tabindex="-1" v-if="ServiceByDateResponce && requestSent">
                            <div class="self-table-info">
                                <div class="flex items-center sm-down:w-full sm-down:justify-between">
                            <span class="block text-base">{{ $t('reports.table.total') }}: <span
                                class="font-semibold whitespace-nowrap">{{
                                    formatSum(totalSum(ServiceByDateResponce))
                                }}</span></span>

                                    <div class="self-table-info-entries-count"></div>
                                </div>

                                <div class="flex items-center sm-down:w-full sm-down:justify-between sm-down:pt-16">
                                    <div class="self-table-info-entries-select"></div>

                                    <div class="relative inline-block">
                                        <div class="relative inline-block ">
                                            <button ref="exportButton" class="self-btn-plain"
                                                    id="export-report"
                                                    aria-haspopup="true" aria-expanded="false"
                                                    @click="dropdown('exportButton')"><span
                                                class="self-btn-plain__text">{{ $t('reports.table.export') }}</span>
                                                <span class="self-btn-plain__icon self-moreinfo-icon">
                                                        <IconArrowForwardSVG/>
                                                    </span>
                                            </button>

                                            <div class="e5-dropdown e5-dropdown-xs" aria-labelledby="export-report">
                                                <div class="p-10">
                                                    <a class="py-5 self-text-link hover:cursor-pointer"
                                                       @click="download('.xlsx', 'summary-service', ServiceByDateResponceSummary)">Excel
                                                        (XLSX)</a>
                                                    <a class="py-5 self-text-link hover:cursor-pointer"
                                                       @click="download('.csv', 'summary-service', ServiceByDateResponceSummary)">CSV</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <table class="w-full self-table">
                                <thead>
                                <tr>
                                    <th><span>{{ $t('reports.table.service_groups') }}</span></th>
                                    <th class="self-table-price sum"><span>{{ $t('reports.table.invoice_sum') }}</span>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in ServiceByDateResponceSummary.entries()" :key="item[0]"
                                    class="summary-row">
                                    <td>{{ item[0] }}</td>
                                    <td class="self-table-price">{{ formatSum(item[1]) }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- Detailed view -->
                        <div class="w-full" id="detailed" role="tabpanel"
                             aria-labelledby="detailed"
                             aria-hidden="true" tabindex="-1" hidden v-if="ServiceByDateResponce && requestSent">

                            <div class="self-table-info">
                                <div class="flex items-center sm-down:w-full sm-down:justify-between">
                            <span class="block text-base">{{ $t('reports.table.total') }}: <span
                                class="font-semibold whitespace-nowrap">{{
                                    formatSum(totalSum(ServiceByDateResponce))
                                }}</span></span>

                                    <div class="self-table-info-entries-count"></div>
                                </div>

                                <div
                                    class="flex items-center sm-down:w-full sm-down:justify-between sm-down:pt-16">
                                    <div class="self-table-info-entries-select"></div>

                                    <div class="relative inline-block">
                                        <div class="relative inline-block ">
                                            <button ref="exportButton2"
                                                    class="self-btn-plain"
                                                    id="export-report2" aria-haspopup="true"
                                                    aria-expanded="false"
                                                    @click="dropdown('exportButton2')"><span
                                                class="self-btn-plain__text"> {{ $t('reports.table.export') }} </span>
                                                <span class="self-btn-plain__icon self-moreinfo-icon"><IconArrowForwardSVG/></span>
                                            </button>

                                            <div class="e5-dropdown e5-dropdown-xs"
                                                 aria-labelledby="export-report2">
                                                <div class="p-10">
                                                    <a class="py-5 self-text-link hover:cursor-pointer"
                                                       @click="download('.xlsx', 'detailed-service')">Excel (XLSX)</a>
                                                    <a class="py-5 self-text-link hover:cursor-pointer"
                                                       @click="download('.csv', 'detailed-service')">CSV</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <table class="w-full self-table self-table--compact">
                                <thead>
                                <tr>
                                    <th><span>{{ $t('reports.table.invoice_no') }}</span></th>
                                    <th class="date"><span>{{ $t('reports.table.service_start_date') }}</span>
                                    </th>
                                    <th class="date"><span>{{ $t('reports.table.service_end_date') }}</span>
                                    </th>
                                    <th>
                                <span>
                                    <select id="departureSelect" class="self-table-header-select">
                                        <option value="">{{ $t('reports.table.all_departures') }}</option>
                                        <option value="blank">{{ $t('reports.table.blank') }}</option>
                                        <option v-for="departure in uniqueDepartures" :key="departure"
                                                :value="departure">{{ departure }}</option>
                                    </select>
                                </span>
                                    </th>
                                    <th>
                                <span>
                                    <select id="destinationSelect" class="self-table-header-select">
                                        <option value="">{{ $t('reports.table.all_destinations') }}</option>
                                        <option v-for="country in uniqueCountries" :key="country"
                                                :value="country">{{ country }}</option>
                                    </select>
                                </span>
                                    </th>
                                    <th>
                                <span>
                                    <select id="passengerSelect" class="self-table-header-select">
                                        <option value="">{{ $t('reports.table.passenger_name') }}</option>
                                        <option v-for="passenger in uniquePassengers" :key="passenger"
                                                :value="passenger">{{ passenger }}</option>
                                    </select>
                                </span>
                                    </th>
                                    <th>
                                <span>
                                    <select id="serviceSelect" class="self-table-header-select">
                                        <option value="">{{ $t('reports.table.all_services') }}</option>
                                        <option v-for="service in uniqueServices" :key="service"
                                                :value="service">{{ service }}</option>
                                    </select>
                                </span>
                                    </th>
                                    <th><span>{{ $t('reports.table.qty') }}</span></th>
                                    <th class="self-table-price sum"><span>{{
                                            $t('reports.table.invoice_sum')
                                        }}</span>
                                    </th>
                                    <th><span>
                                    <select id="serviceProviderSelect" class="self-table-header-select">
                                        <option value="">{{ $t('reports.table.all_service_providers') }}</option>
                                        <option v-for="provider in uniqueServiceProviders" :key="provider"
                                                :value="provider">{{ provider }}</option>
                                    </select>
                                </span></th>
                                    <th>
                                <span>
                                    <select id="consultantSelect" class="self-table-header-select">
                                        <option value="">{{ $t('reports.table.consultant') }}</option>
                                        <option v-for="consultant in uniqueConsultants" :key="consultant"
                                                :value="consultant">{{ consultant }}</option>
                                    </select>
                                </span>
                                    </th>
                                    <th>
                                <span>
                                    <select id="bookedByNameSelect" class="self-table-header-select">
                                        <option value="">{{ $t('reports.table.booked_by') }}</option>
                                        <option v-for="name in uniqueBookedByNames" :key="name"
                                                :value="name">{{ name }}</option>
                                    </select>
                                </span>
                                    </th>
                                    <th><span><select id="salesChannelsSelect"
                                                      class="self-table-header-select">
                                        <option value="">{{ $t('reports.table.sales_channel') }}</option>
                                        <option value="ONLINE">Online</option>
                                        <option value="OFFLINE">Offline</option>
                                    </select></span></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in this.ServiceByDateResponce.services" :key="item.service_id">
                                    <td v-if="item.documents.length > 0 && findInvoice(item.documents) !== undefined">
                                        <a
                                            :href="findInvoice(item.documents).documentId"
                                            @click.prevent="downloadInvoice(findInvoice(item.documents).documentId, findInvoice(item.documents).documentNo)">{{
                                                findInvoice(item.documents).documentNo
                                            }}</a></td>
                                    <td v-else></td>
                                    <td> {{ formatDate(item.servicestartdate) }}</td>
                                    <td> {{ formatDate(item.serviceenddate) }}</td>
                                    <td v-if="item.servicedeparturecountry">
                                        {{ item.servicedeparturecountry + ', ' + item.servicedeparturecity }}
                                    </td>
                                    <td v-else></td>
                                    <td v-if="item.servicedestinationcountry">
                                        {{
                                            item.servicedestinationcountry + ', ' + item.servicedestinationcity
                                        }}
                                    </td>
                                    <td v-else></td>
                                    <td v-if="item.servicepassengerlist[0]"><p
                                        v-for="passenger in item.servicepassengerlist"
                                        :key="passenger.passengerId">{{ passenger.name }}
                                        <br/></p></td>
                                    <td v-else></td>
                                    <td>{{ item.productname }}</td>
                                    <td>{{ item.qty }}</td>
                                    <td class="self-table-price">{{ formatSum(item.ttlsellrate) }}</td>
                                    <td>{{ item.serviceprovider }}</td>
                                    <td>{{ item.travelconsultant }}</td>
                                    <td>{{ item.bookedbyname }}</td>
                                    <td>{{ item.saleschannels }}</td>
                                </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </div>
        </article>
        <!-- Empty response -->
        <article v-if="!ServiceByDateResponce">
            <section id="resultsTable" class="relative bg-blue-100 rounded-b-2xl self-gutter-y">
                <div class="self-gutter">
                    <div class="self-content-sm">

                    <span class="block title-2xl pt-32 pb-[300px] text-black font-normal"
                          v-if="requestSent && responseReceived">{{ $t('reports.table.no_results') }}</span>
                        <span class="block title-2xl pt-32 pb-[300px] text-black font-normal" v-else-if="requestSent">
                        <span class="loading-animation">{{ $t('reports.table.searching') }}<span class="loading-dots">
                            <span class="dot">.</span>
                            <span class="dot">.</span>
                            <span class="dot">.</span>
                        </span></span></span>

                    </div>
                </div>
            </section>
        </article>
    </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import { IReportServiceByDateResponce, IServiceByDateRequest } from '@/domain/IReport'
import { IPassenger } from '@/domain/IPassenger'
import { IBooking } from '@/domain/IBooking'
import { IService } from '@/domain/IService'
import { IToplevel } from '@/domain/IToplevel'
import store from '@/store'
import { ITicket } from '@/domain/ITicket'
import DropDownCalendar from '@/components/DropDownCalendar.vue'
import CalendarSVG from '@/assets/static/icons-src/icon-calendar.svg'
import IconArrowForwardSVG from '@/assets/static/icons-src/icon-arrow-forward.svg'
import ArrowLeftSVG from '@/assets/static/icons-src/est-arrow-left.svg'
import LogoIllustrationSVG from '@/assets/static/icons-src/logo-illustration.svg'
import initTabs from '@/scripts/tabs'
import $ from 'jquery'
import 'select2'
import { IDocument } from '@/domain/IDocument'
import UtilsMixin from '@/scripts/utils'
import moment from 'moment/moment'
import ReportNavigation from '@/components/ReportNavigation.vue'
import Choices from 'choices.js'
import AlertSummary from '@/components/AlertSummary.vue'

@Component({
    components: {
        ReportNavigation,
        DropDownCalendar,
        CalendarSVG,
        IconArrowForwardSVG,
        ArrowLeftSVG,
        LogoIllustrationSVG,
        AlertSummary
    },
    metaInfo: {
        title: 'Service report'
    },
    mixins: [UtilsMixin]
})
export default class Reports extends Vue {
    // Properties
    selectedDateRange = ''
    requestSent = false
    private allSelectedToplevels = true
    private initExtraTable = true
    generateReportOk = true
    SelectedToplevels: IToplevel[] = []
    selectedSalesChannels = ['ONLINE', 'OFFLINE']
    private extraTable = null
    responseReceived = false
    showFullDesc = false

    private selectedCountryCode: string | number | string[] = []
    ServiceByDateRequest: IServiceByDateRequest = {
        invoicedServices: '1',
        saleschannels: '',
        datetype: 'SERVICE_DATE',
        passenger: {
            passengerId: '',
            name: '',
            birthday: '',
            reference: ''
        } as unknown as IPassenger,
        booking: {
            bookingnumber: '',
            bookedbyname: '',
            customerreference: '',
            projectcode: '',
            budgetcode: '',
            employeenumber: '',
            menumber: '',
            finaccount: ''
        } as unknown as IBooking,
        toplevel: {
            toplevel_id: '',
            toplevel_name: ''
        } as unknown as IToplevel[],
        ticket: {
            ticketNo: ''
        } as unknown as ITicket,
        service: {
            id: '',
            servicestartdate: '',
            serviceenddate: '',
            bookingreferencenumber: '',
            servicedestinationcountry: '',
            servicedestinationcity: '',
            productname: ''
        } as unknown as IService,
        customerid: store.state.customerId
    }

    // Computed properties

    get toplevel(): IToplevel[] {
        return store.state.toplevel
    }

    get ServiceByDateResponce(): IReportServiceByDateResponce | null {
        const response = store.state.ReportServiceByDateResponce
        return response && response.services && response.services.length > 0
            ? response
            : null
    }

    get ServiceByDateResponceSummary(): Map<string, number> | null {
        const responseSummary = new Map<string, number>()
        const responce = this.ServiceByDateResponce
        if (responce) {
            responce.services.forEach(service => {
                const serviceGroup = service.productname
                const currentTotal = responseSummary.get(serviceGroup) || 0
                responseSummary.set(serviceGroup, currentTotal + service.ttlsellrate)
            })
        }
        return responseSummary
    }

    get uniqueCountries(): string[] {
        return Array.from(new Set(this.ServiceByDateResponce.services.map((item) => item.servicedestinationcountry))).filter(Boolean).sort()
    }

    get uniqueServiceProviders(): string[] {
        return Array.from(new Set(this.ServiceByDateResponce.services.map((item) => item.serviceprovider))).filter(Boolean).sort()
    }

    get uniqueDepartures(): string[] {
        return Array.from(new Set(this.ServiceByDateResponce.services.map((item) => item.servicedeparturecountry))).filter(Boolean).sort()
    }

    get uniquePassengers(): string[] {
        return Array.from(
            new Set(
                this.ServiceByDateResponce.services
                    .flatMap((item) => item.servicepassengerlist.map((passenger) => passenger.name))
            )
        ).filter(Boolean).sort()
    }

    get uniqueServices(): string[] {
        return Array.from(new Set(this.ServiceByDateResponce.services.map((item) => item.productname))).filter(Boolean).sort()
    }

    get uniqueConsultants(): string[] {
        return Array.from(new Set(this.ServiceByDateResponce.services.map((item) => item.travelconsultant))).filter(Boolean).sort()
    }

    get uniqueBookedByNames(): string[] {
        return Array.from(new Set(this.ServiceByDateResponce.services.map((item) => item.bookedbyname))).filter(Boolean).sort()
    }

    // Methods

    findInvoice(documents): IDocument | null {
        return documents.find(document => document.documentType === 'INVOICE')
    }

    async generateOnClick(ServiceByDateRequest: IServiceByDateRequest) {
        if (this.selectedDateRange.split('—').length !== 2) {
            this.generateReportOk = false
            // if (window.innerWidth < 1024) {
            //     this.scrollToAlertMessage()
            // }
            this.scrollToAlertMessage()
        } else {
            // if (window.innerWidth < 1024) {
            //     this.scrollToResultsTable()
            // }
            this.scrollToResultsTable()
            this.ServiceByDateRequest.customerid = store.getters.getCustomerId
            this.ServiceByDateRequest.toplevel = this.allSelectedToplevels || this.SelectedToplevels.length === 12
                ? []
                : this.SelectedToplevels
            this.ServiceByDateRequest.saleschannels = this.selectedSalesChannels.length === 1
                ? this.selectedSalesChannels[0]
                : ''
            this.generateReportOk = true
            this.requestSent = true
            this.initExtraTable = true
            if (Array.isArray(this.selectedCountryCode)) {
                this.ServiceByDateRequest.service.servicedestinationcountry = this.selectedCountryCode.length > 0
                    ? this.selectedCountryCode[0]
                    : ''
            }
            store.commit('setReportServiceByDateResponce', null)
            this.responseReceived = false
            await store.dispatch('getServicesByDate', ServiceByDateRequest)
            this.responseReceived = true
        }
    }

    // Type Declarations for TypeScript to tell that these methods exist in utils.ts
    scrollToAlertMessage!: () => void
    scrollToResultsTable!: () => void
    initDescriptionExpansion!: () => void

    selectAllTopleveles() {
        this.SelectedToplevels = this.toplevel
    }

    clearAll() {
        this.ServiceByDateRequest = {
            invoicedServices: '1',
            saleschannels: '',
            datetype: 'SERVICE_DATE',
            passenger: {
                passengerId: '',
                name: '',
                birthday: '',
                reference: ''
            } as unknown as IPassenger,
            booking: {
                bookingnumber: '',
                bookedbyname: '',
                customerreference: '',
                projectcode: '',
                budgetcode: '',
                employeenumber: '',
                menumber: '',
                finaccount: ''
            } as unknown as IBooking,
            toplevel: {
                toplevel_id: '',
                toplevel_name: ''
            } as unknown as IToplevel[],
            ticket: {
                ticketNo: ''
            } as unknown as ITicket,
            service: {
                id: '',
                servicestartdate: '',
                serviceenddate: '',
                bookingreferencenumber: '',
                servicedestinationcountry: '',
                servicedestinationcity: '',
                productname: ''
            } as unknown as IService,
            customerid: store.state.customerId
        }
        this.SelectedToplevels = []
        this.allSelectedToplevels = true
        this.requestSent = false
        this.$root.$emit('reset-calendar')
        this.selectedDateRange = ''
        this.destroyExtraTable()
        this.initExtraTable = true
        this.selectedSalesChannels = ['ONLINE', 'OFFLINE']
        this.responseReceived = false
        if (Array.isArray(this.selectedCountryCode)) if (this.choices && this.selectedCountryCode.length > 0) this.choices.removeActiveItemsByValue(this.selectedCountryCode[0])
        this.selectedCountryCode = []
        store.commit('setReportServiceByDateResponce', null)
    }

    clearServiceGroups() {
        this.SelectedToplevels = []
        this.allSelectedToplevels = false
    }

    private choices = null

    private initMultiSelects () {
        if (this.choices) {
            this.choices.destroy()
        }
        const selectElement = document.querySelector('.self-multiselect') as HTMLSelectElement
        if (selectElement === null) return
        const placeholderText = this.$t('reports.form.choose_destination') as string
        this.choices = new Choices(document.querySelector('.self-multiselect'), {
            removeItemButton: true,
            itemSelectText: placeholderText,
            maxItemCount: 2,
            maxItemText: this.$t('reports.form.only_one_can_be_selected') as string,
            noChoicesText: this.$t('reports.form.no_choices_to_choose_from') as string,
            allowHTML: true
        });

        this.choices.passedElement.element.addEventListener('change', (event) => {
            const selectedValues = $(event.target).val() as string[]
            if (selectedValues.length > 1) {
                // Convert the HTMLSelectElement to an array-like object
                const options = Array.from(selectElement.options);

                // Find the option with the specified value and remove it
                const optionToRemove = options.find(option => option.value === selectedValues[0]);
                if (optionToRemove) {
                    selectElement.removeChild(optionToRemove);
                }

                // Update Choices.js instance to reflect the changes
                this.choices.removeActiveItemsByValue(selectedValues[0]);
                selectedValues.splice(0, 1)
                this.choices.setChoiceByValue(selectedValues)
            }
            this.selectedCountryCode = selectedValues;
        }, false);

        this.choices.setChoices(this.$store.state.country, 'country_code', 'country_name');
    }

    private createExtraTable () {
        $.fn.dataTable.ext.errMode = 'throw'
        // Define a custom sorting plugin
        $.fn.dataTable.ext.type.order['formatted-num-asc'] = function (a, b) {
            a = parseFloat(a.replace(/[^\d.-]/g, '').replace(/,/g, '')) || 0
            b = parseFloat(b.replace(/[^\d.-]/g, '').replace(/,/g, '')) || 0
            return a - b
        }

        $.fn.dataTable.ext.type.order['formatted-num-desc'] = function (a, b) {
            a = parseFloat(a.replace(/[^\d.-]/g, '').replace(/,/g, '')) || 0
            b = parseFloat(b.replace(/[^\d.-]/g, '').replace(/,/g, '')) || 0
            return b - a
        }

        // Sorting function for dates in 'DD.MM.YYYY' format
        $.fn.dataTable.ext.type.order['moment-date-asc'] = function (a, b) {
            return moment(a, 'DD.MM.YYYY').isAfter(moment(b, 'DD.MM.YYYY')) ? 1 : -1
        }

        $.fn.dataTable.ext.type.order['moment-date-desc'] = function (a, b) {
            return moment(a, 'DD.MM.YYYY').isBefore(moment(b, 'DD.MM.YYYY')) ? 1 : -1
        }
        // Define a custom filtering function for the destination country column
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex) {
            const selectedCountry = $('#destinationSelect').val()
            // Check if the table has at least 5 columns (assuming destination country column exists)
            if (settings.aoColumns.length < 5) {
                return true
            }
            if (selectedCountry === '') {
                // If no country is selected, show all rows
                return true
            }

            // Check if the data in the destination country column matches the selected country
            const destinationCountryAndCity = data[4] || '' // Use empty string as a default value if undefined
            const destinationCountry = destinationCountryAndCity.split(',')[0].trim()
            return destinationCountry === selectedCountry
        })

        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex) {
            const selectedServiceProvider = $('#serviceProviderSelect').val()
            if (settings.aoColumns.length < 10) {
                return true
            }
            if (selectedServiceProvider === '') {
                return true
            }
            const serviceProvider = data[9] || ''
            return serviceProvider === selectedServiceProvider
        })

        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex) {
            const selectedConsultant = $('#consultantSelect').val()
            if (settings.aoColumns.length < 11) {
                return true
            }
            if (selectedConsultant === '') {
                return true
            }
            const serviceProvider = data[10] || ''
            return serviceProvider === selectedConsultant
        })

        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex) {
            const selectedDeparture = $('#departureSelect').val()
            if (settings.aoColumns.length < 4) {
                return true
            }
            if (selectedDeparture === '') {
                return true
            }
            const departureCountryAndCity = data[3] || ''
            const departureCountry = departureCountryAndCity.split(',')[0].trim()
            if (selectedDeparture === 'blank') {
                return departureCountry === ''
            }
            return departureCountry === selectedDeparture
        })

        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex) {
            const selectedService = $('#serviceSelect').val()
            if (settings.aoColumns.length < 7) {
                return true
            }
            if (selectedService === '') {
                return true
            }
            const service = data[6] || ''
            return service === selectedService
        })

        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex) {
            const selectedBookedByName = $('#bookedByNameSelect').val() as string
            if (settings.aoColumns.length < 12) {
                return true
            }
            if (selectedBookedByName.trim() === '') {
                return true
            }
            const name = data[11].trim() || ''
            return name === selectedBookedByName.trim()
        })

        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex) {
            const selectedPassenger = $('#passengerSelect').val()
            if (settings.aoColumns.length < 6) {
                return true
            }
            if (selectedPassenger === '') {
                return true
            }
            const name = data[5].trim() || ''
            return name === selectedPassenger || name.includes(selectedPassenger)
        })

        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex) {
            const selectedSalesChannel = $('#salesChannelsSelect').val() as string
            if (settings.aoColumns.length < 13) {
                return true
            }
            if (selectedSalesChannel.trim() === '') {
                return true
            }
            const channel = data[12].trim() || ''
            return channel === selectedSalesChannel.trim() || channel.includes(selectedSalesChannel.trim())
        })

        this.destroyExtraTable()
        this.extraTable = $('.self-table').DataTable({
            dom: '<il<t>p>',
            paging: true,
            info: true,
            scrollX: true,
            order: [],
            language: {
                lengthMenu: this.$t('datatable.lengthMenu') as string,
                info: this.$t('datatable.info') as string,
                zeroRecords: this.$t('datatable.zeroRecords') as string,
                paginate: {
                    first: this.$t('datatable.first') as string,
                    last: this.$t('datatable.last') as string,
                    next: this.$t('datatable.next') as string,
                    previous: this.$t('datatable.previous') as string
                }

            },
            columnDefs: [
                {
                    type: 'formatted-num',
                    targets: 'sum'
                },
                {
                    type: 'moment-date',
                    targets: 'date'
                }
            ]
        })

        // Clear the previously appended elements
        const tabSelectors = ['#detailed', '#summary']

        tabSelectors.forEach((tabSelector) => {
            const tab = document.querySelectorAll(tabSelector)
            tab.forEach((element) => {
                const entriesCount = element.querySelector('.self-table-info-entries-count')
                const lengthSelect = element.querySelector('.self-table-info-entries-select')

                if (entriesCount) {
                    entriesCount.innerHTML = ''
                }

                if (lengthSelect) {
                    lengthSelect.innerHTML = ''
                }
            })
        })

        const tables = document.querySelectorAll('.dataTables_wrapper')
        tables.forEach((table) => {
            const prev = table.previousElementSibling
            const entriesCount = prev.querySelector(
                '.self-table-info-entries-count'
            )
            const lengthSelect = prev.querySelector(
                '.self-table-info-entries-select'
            )

            $(table).find('.dataTables_info').appendTo(entriesCount)
            $(table).find('.dataTables_length').appendTo(lengthSelect)
        })

        const selectTags = document.querySelectorAll('.self-table-header-select')
        selectTags.forEach((selectTag) => {
            if (selectTag) {
                selectTag.addEventListener('click', (event) => {
                    event.stopPropagation()
                })
            }
        })

        // Add a change event listener to the select dropdowns
        $('#destinationSelect').on('change', () => {
            // Trigger the DataTables filtering on change
            this.extraTable.draw()
        })
        $('#serviceProviderSelect').on('change', () => {
            this.extraTable.draw()
        })
        $('#consultantSelect').on('change', () => {
            this.extraTable.draw()
        })
        $('#departureSelect').on('change', () => {
            this.extraTable.draw()
        })
        $('#serviceSelect').on('change', () => {
            this.extraTable.draw()
        })
        $('#bookedByNameSelect').on('change', () => {
            this.extraTable.draw()
        })
        $('#passengerSelect').on('change', () => {
            this.extraTable.draw()
        })
        $('#salesChannelsSelect').on('change', () => {
            this.extraTable.draw()
        })
    }

    private destroyExtraTable () {
        if (this.extraTable != null) {
            this.extraTable.destroy()
            this.extraTable = null
        }
    }

    // Handling language changes for datatable, toplevels and destination select and countries
    @Watch('$i18n.locale', { immediate: true })
    async onLocaleChange () {
        await this.fetchInitialData()
        this.SelectedToplevels.forEach((selectedItem) => {
            const matchingItem = this.toplevel.find((item) => item.toplevel_id === selectedItem.toplevel_id)

            if (matchingItem) {
                selectedItem.toplevel_name = matchingItem.toplevel_name
            }
        })
        this.initMultiSelects()
        this.createExtraTable()
        this.initDescriptionExpansion()
    }

    // Utility methods

    private initComponent (): void {
        this.clearAll()
        this.initMultiSelects()
        this.selectAllTopleveles()
    }

    private async fetchInitialData (): Promise<void> {
        await Promise.all([
            store.dispatch('getToplevel'),
            store.dispatch('getCountry')
        ])
    }

    // ============ Lifecycle methods ==========

    async mounted () {
        this.initDescriptionExpansion()
        await this.fetchInitialData()
        this.initComponent()
    }

    updated (): void {
        if (this.ServiceByDateResponce && this.requestSent && this.initExtraTable) {
            this.createExtraTable()
            this.initExtraTable = false
            initTabs()
        }
    }

    destroyed (): void {
        $.fn.dataTable.ext.search.length = 0 // Clear the array of custom search functions
        if (this.choices) this.choices.destroy()
        this.clearAll()
    }
}
</script>

<style scoped>
</style>
